import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { f1 } from "helpers/commonController.js";
import configureStore from "helpers/configureStore";
import AppRoutes from "./routes";
import "styles/index.global.scss";
import safeJsonParse from "utills/jsonParse";

const store = configureStore(window.__APP_STATE__); // eslint-disable-line no-underscore-dangle

const handleMessage = (event) => {
  if (event.data) {
    const params = safeJsonParse(event.data);
    if (params?.session_id) {
      f1({
        session_id: params.session_id,
        response_id: params.response_id,
      });
    }
  }
};

document.addEventListener("message", handleMessage, false);
window.addEventListener("message", handleMessage, false);

const App = () => (
  <ReduxProvider store={store}>
    <BrowserRouter>
      <section>
        <AppRoutes />
      </section>
    </BrowserRouter>
  </ReduxProvider>
);

export default App;
